export default {
  state: {
    videoFeedStarted: 0,
    videoFeedStopped: 0,
    datachannelOpened: 0,
    cameraOpened: 0,
    inboxRequested: 0,
    inboxReceived: 0,
    streamTimeRequested: 0,
    streamTimeReceived: 0,
    cameraStartTime: [],
  },
  mutations: {
    loadState(state, loadedState) {
      Object.keys(loadedState).forEach((key) => {
        state[key] = loadedState[key];
      });
    },
    setCameraTime(state, time) {
      if (state.cameraStartTime.length >= 5) {
        state.cameraStartTime.shift();
      }
      state.cameraStartTime.push(time);
    },
    incrementStat(state, statKey) {
      state[statKey] += 1;
    },
    resetStats(state) {
      Object.keys(state).forEach((key) => {
        if (key !== 'cameraStartTime') {
          state[key] = 0;
        } else {
          state[key] = [];
        }
      });
    },
  },
  actions: {
    loadStateFromLocalStorage({ commit, state }) {
      const storedState = localStorage.getItem('appStats');
      if (storedState) {
        try {
          const parsedState = JSON.parse(storedState);
          commit('loadState', parsedState);
        } catch (error) {
          console.error('Error loading state from localStorage:', error);
        }
      } else {
        localStorage.setItem('appStats', JSON.stringify(state));
      }
    },
    addCameraStartTime({ commit, state }, time) {
      commit('setCameraTime', time);
      localStorage.setItem('appStats', JSON.stringify(state));
    },
    incrementAndSaveStat({ commit, state }, statArray) {
      const statKey = statArray[0];
      commit('incrementStat', statKey);
      localStorage.setItem('appStats', JSON.stringify(state));
    },
    resetStats({ commit, state }) {
      commit('resetStats');
      localStorage.setItem('appStats', JSON.stringify(state));
    },
  },
  getters: {
    statData: (state) => JSON.parse(JSON.stringify(state)),
  },
};
